// | Wrapper around MultiSet providing Decode and Encode instances. For use
// | primarily in transport types.
// |
// | The multiset is serialized as an array of elements, where each element is
// | repeated as many times as its occurence count.
import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMultiSet from "../Data.MultiSet/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSemiring from "../Data.Semiring/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
const MultiSet = x => x;
const showMultiSet = dictShow => Data$dMultiSet.showMultiSet(dictShow);
const semigroupMultiSet = dictOrd => {
  const compare = dictOrd.compare;
  return {append: v => v1 => Data$dMap$dInternal.unsafeUnionWith(compare, Data$dSemiring.intAdd, v, v1)};
};
const ordMultiSet = dictOrd => Data$dMap$dInternal.ordMap(dictOrd)(Data$dOrd.ordInt);
const newtypeMultiSet = {Coercible0: () => {}};
const udecodeMultiSet = dictOrd => {
  const fromArray = Data$dMultiSet.fromArray(dictOrd);
  return dictDecode => (
    {
      unsafeDecode: (() => {
        const $0 = Unscramble.decodeArray(dictDecode.unsafeDecode);
        return x => fromArray($0(x));
      })()
    }
  );
};
const monoidMultiSet = dictOrd => Data$dMultiSet.monoidMultiSet(dictOrd);
const eqMultiSet = dictEq => Data$dMap$dInternal.eqMap(dictEq)(Data$dEq.eqInt);
const encodeMultiSet = dictEncode => (
  {
    encode: (() => {
      const $0 = Data$dFunctor.arrayMap(dictEncode.encode);
      return x => $0(Data$dMultiSet.elems(x));
    })()
  }
);
const decodeMultiSet = dictOrd => {
  const fromArray = Data$dMultiSet.fromArray(dictOrd);
  return dictDecode => (
    {
      decode: (() => {
        const $0 = Foreign$dGeneric$dClass.arrayDecode(dictDecode).decode;
        return x => {
          const $1 = $0(x);
          if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
          if ($1.tag === "Right") { return Data$dEither.$Either("Right", fromArray($1._1)); }
          $runtime.fail();
        };
      })()
    }
  );
};
export {MultiSet, decodeMultiSet, encodeMultiSet, eqMultiSet, monoidMultiSet, newtypeMultiSet, ordMultiSet, semigroupMultiSet, showMultiSet, udecodeMultiSet};
